import axios from 'axios';
import { Profile } from '@/models/auth';

export const getUserInfo = async (token: string): Promise<Profile> => {
  const { data } = await axios.get<Profile>('https://graph.microsoft.com/v1.0/me', {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
};
